import React, { useState, useEffect, useContext } from 'react';
import Button from '@/components/Button/Button';
import t from '@/utils/Language/SaveButton-translations';
import Access, { AccessEventStatuses } from '@/utils/api/odas/access';
import { AccountContext } from '@/context/account.context';
import { toastContext } from '@/context/toast.context';
import { find } from 'lodash';
import { modalContext } from '@/context/modal.context';
import useMixpanel from '@/hooks/useMixpanel';
import { viewportContext } from '@/context/viewport.context';

const SaveButton = ({
  resource,
  buttonType,
  buttonShape,
  buttonBorder,
  additionalClasses,
  secondOrigin = null,
  showButtonTextOnMobile = false,
  showButtonText = true
}) => {
  const [accessEventId, setAccessEventId] = useState({});
  const [isSaved, setIsSaved] = useState(false);
  const account = useContext(AccountContext);
  const { addToast } = useContext(toastContext);
  const modal = useContext(modalContext);
  const { track } = useMixpanel();
  const { isXs } = useContext(viewportContext);

  const saveResource = (e) => {
    if (account.state.isLoggedIn) {
      if (isSaved) {
        setIsSaved(false);
        Access.delete({ accessEventId: accessEventId }).then((resp) => {
          if (!resp?.status == 200) {
            setIsSaved(true);
          }
        });
      } else {
        track('Identified need', { opportunity_title: resource.title, organization_name: resource.organization?.name });
        setIsSaved(true); // optimistically update the UI
        Access.createOrUpdate({ resource: resource, status: AccessEventStatuses.planned, secondOrigin }).then((resp) => {
          if (resp?.data?.id) {
            setAccessEventId(resp.data.id);
            addToast({
              withHtml: true,
              message: t('You have successfully added "X"', { resourceName: resource.title, link: process.env.PUBLIC_URL + '/plan' }),
              type: 'success'
            });
          } else {
            setIsSaved(false);
          }
        });
      }
    } else {
      track('Signup prompted', { source: 'save button', resource_id: resource.id, resource_type: resource.resource_type });
      //TODO: create a post login property, and save the resource after they login?
      modal.enqueueModal({ name: 'SignupModal' }, { forceOpen: true });
    }
  };

  const getAccessEvent = (fetch) => {
    let planned_access_event = find(account.accessEvents?.planned, (ae) => {
      return ae.fetchable_type == resource.resource_type && ae.fetchable_id == resource.id;
    });
    setAccessEventId(planned_access_event?.id);
    setIsSaved(!!planned_access_event);
  };

  useEffect(() => {
    getAccessEvent();
  }, [account.accessEvents]);

  const getButtonText = () => {
    if (!showButtonText) return '';
    if (!showButtonTextOnMobile && isXs) {
      return '';
    } else {
      return isSaved ? 'Saved' : 'Save';
    }
  };

  return (
    <Button
      type={buttonType || 'default'}
      border={buttonBorder || false}
      shape={buttonShape || 'pill'}
      icon={{ style: isSaved ? 'fas' : 'far', font: 'heart', color: isSaved ? 'red' : '' }}
      text={t(getButtonText())}
      onButtonClick={saveResource}
      additionalClasses={additionalClasses}
    />
  );
};

export default SaveButton;
